module.exports = __webpack_public_path__ + "static/media/stockhausen_nowald_5.786577b6.jpeg";